import React from "react";
import { useNavigate } from "react-router-dom";

import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";
import "./home-page.css";

const plans = [
  {
    id: "gratuito",
    name: "Gratuito",
    label: "Per iniziare",
    price: "0",
    description:
      "Per creare un menu digitale essenziale e iniziare a conoscere QrMenu.",
    buttonText: "Prova gratis",
    buttonRoute: "/demo",
    features: [
      "Menu digitale con QR code",
      "Fino a 50 piatti",
      "Categorie del menu",
      "Descrizioni e allergeni",
      "Aggiornamento autonomo",
      "Nessuna app per il cliente",
    ],
  },
  {
    id: "essenziale",
    name: "Essenziale",
    label: "Per il menu completo",
    price: "4,90",
    description:
      "Per chi desidera un menu digitale professionale, completo di foto e senza limite di piatti.",
    buttonText: "Scegli Essenziale",
    buttonRoute: "/contatti",
    features: [
      "Tutto del piano Gratuito",
      "Piatti senza limite",
      "Foto dei piatti",
      "Descrizioni complete",
      "Allergeni e categorie",
      "Aggiornamenti illimitati",
    ],
  },
  {
    id: "pro",
    name: "Pro",
    label: "Per ristoranti e pizzerie",
    price: "14,90",
    description:
      "Per collegare menu, ordini, cucina e personale di sala in un unico sistema.",
    buttonText: "Scegli Pro",
    buttonRoute: "/contatti",
    featured: true,
    features: [
      "Tutto del piano Essenziale",
      "Ordini dal tavolo",
      "Gestione ordini in cucina",
      "Stampa automatica opzionale",
      "Chiamata cameriere",
      "Notifiche per la sala",
      "1 accesso cameriere",
      "Logo personalizzato",
    ],
  },
  {
    id: "business",
    name: "Business",
    label: "Per il sistema completo",
    price: "24,90",
    oldPrice: "29,90",
    description:
      "Per usare tutto l’ecosistema QrMenu, con asporto e intelligenza artificiale per cliente, sala e gestione del menu.",
    buttonText: "Attiva la promo",
    buttonRoute: "/contatti",
    featured: true,
    features: [
      "Tutto del piano Pro",
      "Suggerimenti intelligenti per il cliente",
"Alert intelligenti per aiutare la sala",
"Traduzioni con intelligenza artificiale",
"Generazione immagini dei piatti",
      "Asporto con verifica OTP",
      "Slot orari per il ritiro",
      "Camerieri illimitati",
      "Giochi e funzioni avanzate",
      "Supporto prioritario",
    ],
  },
];

const faqs = [
  {
    question: "Posso cambiare piano in seguito?",
    answer:
      "Sì. Puoi partire dal piano più semplice e passare a un piano superiore senza dover ricreare il menu o cambiare QR code.",
  },
  {
    question: "Gli ordini dal tavolo sono obbligatori?",
    answer:
      "No. Anche nei piani che includono gli ordini, è sempre il gestore a decidere se attivarli.",
  },
  {
    question: "Il cliente deve scaricare un’app?",
    answer:
      "No. Il cliente apre il menu direttamente dal browser tramite QR code, senza registrazione e senza installare applicazioni.",
  },
  {
    question: "La stampa automatica è compresa nel piano Pro?",
    answer:
      "La funzione di stampa automatica opzionale è disponibile dal piano Pro. Per utilizzarla è necessaria una stampante compatibile e la configurazione di QrPrint.",
  },
  {
    question: "Il prezzo Business di 24,90 € è promozionale?",
    answer:
      "Sì. Il prezzo ordinario del piano Business è 29,90 € al mese. La promozione attuale riduce il prezzo a 24,90 € al mese.",
  },
];

export default function Pricing() {
  const navigate = useNavigate();

  return (
    <div className="home-pro">
      <SEO
        title="Piani e prezzi QrMenu Italia"
        description="Scopri i piani QrMenu Italia: Gratuito, Essenziale, Pro e Business. Menu digitale, ordini, cucina, sala, asporto e intelligenza artificiale."
        canonical="https://qrmenu-italia.it/piani"
        image="https://qrmenu-italia.it/og-home-v2.jpg"
        keywords="piani qrmenu, prezzi menu qr, costo menu digitale, menu digitale ristorante prezzo, ordini ristorante, intelligenza artificiale ristoranti"
        faq={faqs}
      />

      <MarketingNavbar />

      {/* HERO */}
      <section className="hp-hero">
        <div className="hp-hero-noise" />
        <div className="hp-hero-glow" />

        <div className="hp-hero-inner">
          <div className="hp-hero-eyebrow">
            <span className="hp-dot" />
            Piani QrMenu
          </div>

          <h1 className="hp-hero-h1">
            Scegli il piano giusto
            <span className="hp-hero-accent">
              per il tuo locale.
            </span>
          </h1>

          <p className="hp-hero-sub">
            Parti da un semplice menu digitale oppure attiva ordini, cucina,
            sala, asporto e intelligenza artificiale.
          </p>

          <div className="hp-hero-pills">
            <span className="hp-pill">
              ✦ Nessuna app per il cliente
            </span>

            <span className="hp-pill">
              ✦ Attivazione guidata
            </span>

            <span className="hp-pill">
              ✦ Puoi cambiare piano
            </span>
          </div>

          <div className="hp-hero-actions">
            <button
              className="hp-btn-demo"
              onClick={() => navigate("/demo")}
            >
              Prova Gratis 7 Giorni
            </button>

            <button
              className="hp-btn-primary"
              onClick={() => navigate("/contatti")}
            >
              Richiedi informazioni
            </button>
          </div>
        </div>

<div className="hp-hero-mockup">
  <div className="hp-feat-card hp-feat-card--featured">
    <div className="hp-section-tag">
      Promo Business
    </div>

    <h2 className="hp-section-h2">
      Piano Business
    </h2>

<p className="hp-feat-desc">
  Il piano completo QrMenu con menu digitale, ordini, cucina,
  sala, asporto e intelligenza artificiale per aiutare clienti,
  personale e gestore.
</p>

    <p
      style={{
        margin: "24px 0 4px",
        color: "var(--c-muted)",
        textDecoration: "line-through",
        fontSize: "1rem",
      }}
    >
      € 29,90 / mese
    </p>

    <div
      style={{
        fontSize: "clamp(2.8rem, 6vw, 4rem)",
        fontWeight: 800,
        lineHeight: 1,
        color: "var(--c-green)",
        marginBottom: "10px",
      }}
    >
      € 24,90
    </div>

    <p className="hp-feat-desc">
      al mese
    </p>

    <button
      className="hp-btn-demo"
      onClick={() => navigate("/contatti")}
    >
      Attiva la promo
    </button>
  </div>
</div>
      </section>

      {/* PIANI */}
      <section className="hp-features">
        <div className="hp-section-tag">
          Scegli il tuo piano
        </div>

        <h2 className="hp-section-h2">
          Prezzi semplici e funzioni chiare
        </h2>

        <div className="hp-features-grid">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={
                plan.featured
                  ? "hp-feat-card hp-feat-card--featured"
                  : "hp-feat-card"
              }
            >
              <div className="hp-section-tag">
                {plan.label}
              </div>

              <h3 className="hp-feat-title">
                {plan.name}
              </h3>

              <p className="hp-feat-desc">
                {plan.description}
              </p>

              {plan.oldPrice && (
                <p className="hp-feat-desc">
                  <s>€ {plan.oldPrice}</s>
                </p>
              )}

              <h3 className="hp-section-h2">
                € {plan.price}
                <span
                  style={{
                    fontSize: "1rem",
                    fontWeight: 400,
                    marginLeft: "6px",
                  }}
                >
                  /mese
                </span>
              </h3>

              <ul
                style={{
                  paddingLeft: "18px",
                  color: "var(--c-muted)",
                  lineHeight: 1.8,
                  marginBottom: "28px",
                }}
              >
                {plan.features.map((feature) => (
                  <li key={feature}>
                    {feature}
                  </li>
                ))}
              </ul>

              <button
                className={
                  plan.id === "business"
                    ? "hp-btn-demo"
                    : "hp-btn-primary"
                }
                onClick={() =>
                  navigate(plan.buttonRoute)
                }
              >
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* BUSINESS */}
      <section className="hp-ai">
        <div className="hp-ai-inner">
          <div className="hp-section-tag">
            Promo Business
          </div>

          <h2 className="hp-section-h2">
            Il piano completo ora costa meno
          </h2>

          <p className="hp-seo-text">
            Il piano Business passa da 29,90 € a
            <strong> 24,90 € al mese</strong>.
          </p>

          <button
            className="hp-btn-demo"
            onClick={() => navigate("/contatti")}
          >
            Richiedi l’attivazione
          </button>
        </div>
      </section>

      {/* CONFRONTO SEMPLICE */}
      <section className="hp-problem">
        <div className="hp-problem-inner">
          <div className="hp-section-tag">
            Quale piano scegliere
          </div>

          <h2 className="hp-section-h2">
            Parti semplice e aggiungi solo quello che ti serve
          </h2>

          <div className="hp-problem-cards">
            <div className="hp-problem-card">
              <h3>Gratuito ed Essenziale</h3>

              <p>
                Per chi vuole principalmente un menu digitale sempre
                aggiornabile, senza funzioni operative avanzate.
              </p>
            </div>

            <div className="hp-problem-card">
              <h3>Pro</h3>

              <p>
                Per collegare il menu agli ordini dal tavolo, alla cucina,
                alla stampa e al personale di sala.
              </p>
            </div>

            <div className="hp-problem-card">
              <h3>Business</h3>

<p>
  Per aggiungere anche asporto, slot orari e intelligenza artificiale
  per aiutare il cliente nella scelta, supportare la sala e semplificare
  contenuti e traduzioni del menu.
</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="hp-faq">
        <div className="hp-faq-inner">
          <div className="hp-section-tag">
            Domande frequenti
          </div>

          <h2 className="hp-section-h2">
            Prima di scegliere
          </h2>

          <div className="hp-faq-grid">
            {faqs.map((faq) => (
              <div
                key={faq.question}
                className="hp-faq-card"
              >
                <h3>{faq.question}</h3>
                <p>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINALE */}
      <section className="hp-final">
        <div className="hp-final-noise" />

        <div className="hp-final-inner">
          <h2 className="hp-final-h2">
            Vuoi capire quale piano è più adatto?
          </h2>

          <p className="hp-final-sub">
            Prova QrMenu gratuitamente oppure contattaci per scegliere
            insieme la configurazione migliore per il tuo locale.
          </p>

          <div className="hp-hero-actions">
            <button
              className="hp-btn-demo"
              onClick={() => navigate("/demo")}
            >
              Prova Gratis 7 Giorni
            </button>

            <button
              className="hp-btn-primary"
              onClick={() => navigate("/contatti")}
            >
              Contattaci
            </button>
          </div>
        </div>
      </section>
            <MarketingFooter />
    </div>
  );
}